<h4 class="re-container-with-margin re-mb-20 re-mt-60 md:re-mb-30 re-ml-20 md:re-ml-auto">
  {{ 'personaldata.optin.title' | translate }}
</h4>

<div class="re-container-with-margin re-mx-0 md:re-mx-auto" data-qa="optinErrorbox">
  @if (state === LoadingState.ERROR) {
    <bdo-info-box>
      {{ 'general.error.error' | translate }}
    </bdo-info-box>
  }
</div>

<bdo-edit-card
  class="re-relative"
  [isEditable]="!isInEditMode"
  [disabled]="disabled"
  (edit)="onEdit()">
  @if (state === LoadingState.LOADING) {
    <bdo-loading></bdo-loading>
  }

  @if (checkedOptin || isInEditMode) {
    <bdo-checkbox
      [checked]="checkedOptin"
      [disabled]="!isInEditMode"
      (change)="checkedOptin = !checkedOptin"
      data-qa="communicationAcceptedCheckbox">
    <div [innerHTML]="(isInEditMode ? 'legal.accepted' :
                      'personaldata.optin.acceptedShort') | translate:
                      { companyName: reBaseData.companyName }">
      </div>
    </bdo-checkbox>
  }
  @if (!checkedOptin && !isInEditMode) {
    <div>
      {{ 'personaldata.optin.deniedShort' | translate:
      { companyName: reBaseData.companyName } }}
    </div>
  }

  @if (isInEditMode) {
    <div>
      <div class="re-mb-15 re-mt-45">
        <button class="bdo-button-primary bdo-button--text" type="submit" (click)="onSave()">
          {{ 'general.action.save' | translate }}
        </button>
      </div>
      <button class="bdo-nolink" data-qa="cancel" type="button" (click)="onEditDone()">
        <div class="bold">{{ 'general.action.cancel' | translate }}</div>
      </button>
    </div>
  }

</bdo-edit-card>
